// src/utils/formatUTC.js
export function formatUTC(isoOrDate) {
  if (!isoOrDate) return "";
  try {
    const d = typeof isoOrDate === "string" ? new Date(isoOrDate) : new Date(isoOrDate);
    return new Intl.DateTimeFormat("en-IN", {
      timeZone: "UTC",        // <-- important: don't shift timezone
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    }).format(d);
  } catch (e) {
    return String(isoOrDate);
  }
}

export default formatUTC;
